<template>
  <v-app>
    <v-hover v-slot="{ hover }">
      <v-snackbar
        :elevation="hover ? 16 : 2"
        :timeout="hover ? -1 : snackbar.timeout"
        top
        center
        :color="snackbar.color"
        v-model="snackbar.show"
      >
        <div style="line-break: anywhere;" v-html="snackbarText"></div>
        <template v-slot:action="{ attrs }">
          <v-btn dark v-bind="attrs" @click.native="snackbar.show = false" icon>
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </template>
      </v-snackbar>
    </v-hover>

    <template v-if="!isPublic">
     <app-core-admin-app-bar v-if="isAdmin" />
    <app-core-app-bar app v-if="!isAdmin && isLoggedIn" />

    <app-core-drawer app v-if="isLoggedIn" />
        <v-main class="d-flex flex-column pb-1">
            <div class="scrollable-content flex-grow-1 overflow-auto background-color">
                <router-view />
            </div>
        </v-main>

    <app-core-footer v-if="!isLoggedIn" class="main-footer" />
    <app-core-footer v-if="isLoggedIn" class="main-footer" style="margin-left: 60px;" />

    </template>
    <template v-else>
      <transition>
        <keep-alive>
          <router-view :key="$route.fullpath"></router-view>
        </keep-alive>
      </transition>
    </template>
  </v-app>
</template>

<script>
import AppEvents from './event';
import axios from 'axios';
export default {
    name: 'App',
    components: {
        AppCoreAppBar: () => import('./components/core/AppBar'),
        AppCoreAdminAppBar: () => import('./components/core/AdminAppBar'),
        AppCoreDrawer: () => import('./components/core/Drawer'),
        AppCoreFooter: () => import('./components/core/Footer'),
    },
    data() {
        return {
            snackbar: {
                show: false,
                text: '',
                color: '',
                timeout: 3000
            },
        };
    },
    computed: {
        isPublic() {
            if (this.$route && this.$route.meta) return this.$route.meta.public;
            return true;
        },
        snackbarText() {
            const errorMessage = this.snackbar.text;

            if (typeof errorMessage !== 'string') {
                return errorMessage.error_description
                    .replaceAll('\n', '<br/>')
                    .replaceAll('\r\n', '<br/>');
            }
            return errorMessage
                .replaceAll('\n', '<br/>')
                .replaceAll('\r\n', '<br/>');
        },
        isAdmin() {
            return (
                this.$store.getters['account/user'] &&
                this.$store.getters['account/user'].IsAdmin
            );
        },
        isLoggedIn() {
            return this.$store.getters['account/isLoggedIn'];
        },
        drawerVisible() {
            return !this.$vuetify.breakpoint.mobile;
        }
    },
    created() {
        AppEvents.forEach(item => {
            this.$on(item.name, item.callback);
        });
        window.getApp = this;

        axios.interceptors.response.use(undefined, function(err) {
            return new Promise(function() {
                if (err.response) {
                    if (

                        err.response.status === 401 &&
                        err.config &&
                        !err.config.__isRetryRequest &&
                        !window.location.hash.substring(2).startsWith('external')
                    ) {
                        const user = window.getApp.$store.getters['account/user'];
                        const organizationHasSamlSettings = localStorage.getItem('organizationHasSamlSettings');
                        const redirectUrl = window.location.hash.substring(1);
                        window.getApp.$emit(
                            'APP_LOGOUT',
                            redirectUrl.includes('login') ? '' : redirectUrl,
                            (organizationHasSamlSettings != null && organizationHasSamlSettings === 'true') ? user.OrganizationID : null
                        );
                    }

                    if (
                        err.response.status === 403 &&
                        err.config &&
                        !err.config.__isRetryRequest &&
                        !window.location.hash.substring(2).startsWith('external')
                    ) {
                        window.getApp.$emit('APP_ACCESS_DENIED', err.response.data);
                    }

                    if (err.response.status === 400 && err.response.data) {
                        if (err.response.data.detail) {
                            window.getApp.$emit('APP_BAD_REQUEST', err.response.data.detail);
                        } else {
                            window.getApp.$emit('APP_BAD_REQUEST', err.response.data);
                        }
                    }
                } else {
                    window.getApp.$emit('APP_BAD_REQUEST', err.message);
                }
                throw err;
            });

        });

        axios.get('/config.json').then(resp => {
            this.$store.dispatch('account/setApiUrl', resp.data.apiUrl);
            this.$store.dispatch(
                'account/setDefaultLanguage',
                resp.data.defaultLanguage
            );
            this.$store.dispatch(
                'account/setLoginParams',
                resp.data.siteConfig.loginParams
            );

            this.$store.dispatch(
                'account/setNewsletter',
                resp.data.siteConfig.newsletter
            );
            this.$store.dispatch('theme/load', resp.data.siteConfig);
            this.$vuetify.theme.dark = resp.data.siteConfig.dark;
            this.$vuetify.theme.themes[
                resp.data.siteConfig.dark ? 'dark' : 'light'
            ].primary = resp.data.siteConfig.color;
        });
    }
};
</script>
<style>
html, body, #app {
  height: 100%;
  margin: 0;
}

.v-main, .v-app-bar, .background-color {
  background-color: #eee !important;
}

.main-footer {
    position: sticky;
    bottom: 0;
    right: 0;
    left: 0;
    z-index: 1;
}

.main-content {
    flex: 1;
    display: flex;
    flex-direction: column;
    overflow: hidden;
    padding-bottom: 4px;
}

.scrollable-content {
    flex: 1;
    overflow-y: auto;
    padding-bottom: 45px;
}
</style>